import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
// The locale-aware date helpers live in `@/lib/format` (alongside the number
// helpers); they are re-exported here so existing `@/lib/utils` imports keep
// working. New code should import from `@/lib/format` directly.
export { formatDate, formatDateTime } from '@/lib/format';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
